import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import LottieView    from 'lottie-react-native';
import { StyleSheet, View, TouchableOpacity, Platform } from 'react-native';
import { Input, Text, Button, Icon, Line, Routes, Colors } from '../components';
import { ArrayUtils, StringUtils } from '../utils';
import PetController from '../controllers/petController';
import { useNavigate, useLocation } from 'react-router-dom';

let screenRef = React.createRef();

class ConsultationStartPets_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pets: [],
      animation_started: false,
    }

    this.onAddPet  = this.onAddPet.bind(this);
    this.pull_pets = this.pull_pets.bind(this);
  }

  componentDidMount() {

  }

  componentDidUpdate() {
    if (this.cat_animation && !this.state.animation_started) {
      this.cat_animation.play();
      this.setState({ animation_started: true });
    }
  }

  async pull_pets() {
    let pets_response = await PetController.getAllPets();

    if(pets_response && pets_response.success && pets_response.pets) {
      let pets = pets_response.patients;

      let pet_details_array = pets.map((pet) => {
        let details = pet && pet.patient_details ? ArrayUtils.getSingleObject(pet.patient_details) : null;
        return details;
      }).filter((deets) => { return deets });

      this.setState({ pets: pet_details_array });
    } else {
      this.setState({ pets: [] });
    }
  }

  async componentDidMount() {
    this.pull_pets();
  }

  async onAddPet() {
    let pets_response = await PetController.getAllPets();

    if(pets_response && pets_response.success && pets_response.pets) {
      this.setState({
        pets: pets_response.pets
      })
    }
  }

  render_pets_rows = () => {
    let pets         = this.state.pets || [];
    let pet_consults = this.props.pet_consults || {};

    let pet_rows = pets.map((pet) => {

      let pet_id   = pet._id;
      let pet_name = pet.name ? StringUtils.displayName(pet) : pet.name;
      let gender   = StringUtils.sentenceCase(pet.gender.toLowerCase());
      let type     = StringUtils.sentenceCase(pet.type.toLowerCase());
      let descrpt  = gender + ' ' + type;
      let age      = '';

      if (pet.age) {
        age = ', Age ' + pet.age;
      }

      let description_str = descrpt + age;
      let description_clr = '#575762';

      let consults_for_pet     = pet_consults && pet_consults[pet_id] ? pet_consults[pet_id] : null;
      let one_or_more_consults = consults_for_pet && (consults_for_pet.async_chat || consults_for_pet.chat || consults_for_pet.video);
      let is_loading_row       = this.props.loading_care_form && this.props.selected_pet === pet_id;

      if (one_or_more_consults) {
        description_str = this.get_consultation_count_string(consults_for_pet);
        description_clr = Colors.PRIMARY;
      }

      return <View key={pet_id}>
        <TouchableOpacity style={styles.pet_row_container}
                          onPress={ () => {
                            this.props.continue_action(pet_id);
                          }}>
          <View>
            <Text style={{ fontSize: 16, fontWeight: '500', color: '#535353' }}>{ pet_name }</Text>
            <Text style={{ fontSize: 14, color: description_clr, marginTop: 3 }}>{ description_str }</Text>
          </View>
          { is_loading_row ? <Progress.CircleSnail size={25} indeterminate={true} color={ Colors.PRIMARY } />
                           : <Icon name='circle-chevron-right' solid={true} size={20} color={Colors.PRIMARY} /> }

        </TouchableOpacity>
        <Line />
      </View>
    })

    if (pet_rows.length === 0) {
      let is_mobile = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;
      return <View style={{ alignItems: 'center', marginBottom: 40 }}>
        { is_mobile ? <LottieView ref={animation => { this.cat_animation = animation }} style={{ width: 140, height: 140, backgroundColor: '#F7F8FA' }} source={require('../assets/animations/cat-tail-wag.json')} />
                    : <Icon name={'cat'} solid={true} size={80} style={{ marginBottom: 20 }} /> }
        <Text style={{ fontSize: 18, color: 'grey', textAlign: 'center' }}>You have not added any pets to your account.</Text>
      </View>
    }

    return <View>
      { pet_rows.length > 0 ? <View>
        <Text style={{ fontSize: 17, color: '#000000', fontWeight: '500' }}>Select a pet from the list below to get started</Text>
      </View> : null }
      { pet_rows }
    </View>
  }

  render_add_pet_button = () => {
    return <View style={{ marginTop: 15 }}>
      <TouchableOpacity onPress={ () => { this.props.navigate(Routes.PET_ADD) }} style={{ flexDirection: 'row', alignItems: 'center' }}>
        <Icon name='plus-circle' solid={true} />
        <View style={{ marginLeft: 15 }}>
          <Text style={{ fontSize: 16, fontWeight: '500', color: '#535353' }}>{ 'Add A New Pet' }</Text>
          <Text style={{ fontSize: 14, color: '#575762', marginTop: 3 }}>{ 'Add a new pet before starting a session' }</Text>
        </View>
      </TouchableOpacity>
      <Line style={{ marginTop: 15 }} />
    </View>
  }

  // <Button title='Add New Pet'
  //         onPress={ () => {
  //           this.props.navigate(Routes.PET_ADD)
  //         }}/>

  render_add_pet_title = () => {
    return null;

    return <View style={{ marginTop: 20, marginBottom: 5 }}>
      <Text style={{ fontSize: 18, color: '#000000', fontWeight: '500' }}>Would you like to add a new pet?</Text>
    </View>
  }

  render() {

    return (
      <View style={styles.main_container}>

        <View>
          { this.render_pets_rows()      }
          { this.render_add_pet_title()  }
          { this.render_add_pet_button() }
        </View>

      </View>
    );
  }

  get_consultation_count_string = (pet_consultation_count) => {
    let count_string = '';

    if (pet_consultation_count.async_chat) {
      count_string = count_string + pet_consultation_count.async_chat + ' Active Chat';
    }

    if (pet_consultation_count.chat) {
      count_string = count_string ? count_string + ', ' : '';
      count_string = count_string + pet_consultation_count.chat + ' Active Live Chat';
    }

    if (pet_consultation_count.live_video) {
      // count_string = count_string + pet_consultation_count.live_video + ' Live Videos ';
    }

    if (pet_consultation_count.video) {
      count_string = count_string ? count_string + ', ' : '';
      count_string = count_string + pet_consultation_count.video + ' Video Appointment ';
    }

    return count_string;
  }

}

const useLocationChange = (action) => {
  const location = useLocation()
  React.useEffect(() => { action(location);  }, [location])
}

function ConsultationStartPets(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    useLocationChange((location) => {
      screenRef.pull_pets();
    })

    return  <ConsultationStartPets_Base ref={node=>{screenRef = node}} {...props} navigate={navigate} />
  } else {
    props.navigation.addListener( 'focus', () => { screenRef ? screenRef.pull_pets() : null });
    return  <ConsultationStartPets_Base ref={node=>{screenRef = node}} {...props} navigate={props.navigation.push}  />
  }
}

const styles = StyleSheet.create({
  main_container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 20
  },
  pet_row_container: {
    marginTop: 20,
    marginBottom: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
});

export default ConsultationStartPets
